module.exports = __webpack_public_path__ + "fonts/fa-solid-900.c960823.eot";